<template>
  <div>
    <AlertDismiss ref="alertDismissExternal" class="mt-2"></AlertDismiss>
    <b-modal
      v-model="showModal"
      scrollable
      centered
      hide-footer
      sticky-header
      header-bg-variant="dark"
      v-bind="$attrs"
    >
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-warning" @click="close()">
          Cerrar
        </b-button>
      </template>

      <AlertDismiss ref="alertDismiss"></AlertDismiss>

      <slot></slot>

      <template #modal-footer>
        <slot name="modal-footer"></slot>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
  name: 'BaseModal',

  components: {
    AlertDismiss
  },

  inheritAttrs: false,

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    showAlert(message, variant = 'danger') {
      if (this.$refs.alertDismiss) {
        this.$refs.alertDismiss.showAlert(message, variant)
      }
    },
    showAlertExternal(message, variant = 'danger') {
      if (this.$refs.alertDismissExternal) {
        this.$refs.alertDismissExternal.showAlert(message, variant)
      }
    }
  }
}
</script>